module.exports = __webpack_public_path__ + "static/img/边框8.ae31c35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框8.svg
// module id = 1Lfv
// module chunks = 2